import React from 'react';
import { Link } from 'react-router-dom';
import { find } from 'lodash';
import Chip from 'material-ui/Chip';
import RaisedButton from 'material-ui/RaisedButton';
import theme from '../../../muiTheme';

const styles = {
  chipLabelStyle: {
    fontSize: '12px',
    lineHeight: '26px'
  },
  chipStyle: {
    marginRight: '10px'
  }
};

const IncidentDetailsHeader = ({ incident, auth, directorGroup }) => {
  function getTags(incident) {
    if (!incident) return null;

    const tags = [];

    // if an incident is not valid,
    // show only the invalid chip/tag and do not show any other chips/tags
    if (incident.attributes.IsValid === 0) {
      tags.push(
        <Chip
          labelStyle={styles.chipLabelStyle}
          style={styles.chipStyle}
          backgroundColor={theme.palette.accent1Color}
          labelColor={theme.palette.canvasColor}
          key="invalid"
        >
          Invalid
        </Chip>
      );
      if (incident.derived.hasOR && !incident.derived.isResponseParent) {
        tags.push(
          <Chip
            labelStyle={styles.chipLabelStyle}
            style={styles.chipStyle}
            backgroundColor={theme.palette.accent2Color}
            labelColor={theme.palette.canvasColor}
            key="providingresponse"
          >
            Providing Response
          </Chip>
        );
      }

      return tags;
    }

    // otherwise, if an incident is valid,
    // attempt to show other chips/tags
    if (incident.attributes.IncidentTypeCategory === 'CX') {
      tags.push(
        <Chip
          labelStyle={styles.chipLabelStyle}
          style={styles.chipStyle}
          backgroundColor={theme.palette.primary2Color}
          labelColor={theme.palette.canvasColor}
          key="complex"
        >
          Complex
        </Chip>
      );
    }

    if (incident.derived.hasConflict) {
      tags.push(
        <Chip
          labelStyle={styles.chipLabelStyle}
          style={styles.chipStyle}
          backgroundColor={theme.palette.accent1Color}
          labelColor={theme.palette.canvasColor}
          key="conflict"
        >
          Potential Conflict
        </Chip>
      );
    }

    if (incident.derived.hasOR && !incident.derived.isResponseParent) {
      tags.push(
        <Chip
          labelStyle={styles.chipLabelStyle}
          style={styles.chipStyle}
          backgroundColor={theme.palette.accent2Color}
          labelColor={theme.palette.canvasColor}
          key="providingresponse"
        >
          Providing Response
        </Chip>
      );
    }

    if (incident.derived.hasOR && incident.derived.isResponseParent) {
    }

    if (incident.derived.hasMerge) {
      tags.push(
        <Chip
          labelStyle={styles.chipLabelStyle}
          style={styles.chipStyle}
          backgroundColor={theme.palette.accent2Color}
          labelColor={theme.palette.canvasColor}
          key="merge"
        >
          Merged {incident.derived.isMergeParent ? '(Consumer)' : '(Consumed)'}
        </Chip>
      );
    }
     if (incident.derived.hasPrescribed) {
          tags.push(
              <Chip
                  labelStyle={styles.chipLabelStyle}
                  style={styles.chipStyle}
                  backgroundColor={theme.palette.accent5Color}
                  labelColor={theme.palette.canvasColor}
                  key="prescribed"
              >
                Prescribed Fire Escape
              </Chip>
          );
        }
      if (incident.derived.hasPostFire) {
          tags.push(
              <Chip
                  labelStyle={styles.chipLabelStyle}
                  style={styles.chipStyle}
                  backgroundColor={theme.palette.accent6Color}
                  labelColor={theme.palette.canvasColor}
                  key="postfire"
              >
                Post Fire Relationship
              </Chip>
          );
        }

    if (incident.attributes.IsQuarantined) {
      tags.push(
        <Chip
          labelStyle={styles.chipLabelStyle}
          style={styles.chipStyle}
          backgroundColor={theme.palette.accent1Color}
          labelColor={theme.palette.canvasColor}
          key="quarantine"
        >
          Quarantined
        </Chip>
      );
    }

    if (incident.attributes.ADSPermissionState === 'CERTIFIED') {
      tags.push(
        <Chip
          labelStyle={styles.chipLabelStyle}
          style={styles.chipStyle}
          backgroundColor={theme.palette.primary2Color}
          labelColor={theme.palette.canvasColor}
          key="certified"
        >
          Certified
        </Chip>
      );
    }
        if (incident.attributes.ADSPermissionState === 'FIREREPORTING') {
      tags.push(
        <Chip
          labelStyle={styles.chipLabelStyle}
          style={styles.chipStyle}
          backgroundColor={theme.palette.accent4Color}
          labelColor={theme.palette.canvasColor}
          key="firereporting"
        >
          Fire Reporting
        </Chip>
      );
    }

    return tags;
  }

  function checkDirectorGroup(auth, directorGroup) {
    const protocol = window.location.protocol;
    const host = window.location.host;

    // Check that the user is in the Director auth group
    if (auth.user && auth.user.groups) {
      if (find(auth.user.groups, ['id', directorGroup])) {
        return (
          <a
            href={`${protocol}//${host}/director/${
              incident ? incident.attributes.IrwinID : null
            }`}
            target="_blank"
            style={{ marginRight: '2rem' }}
          >
            Edit in Director
          </a>
        );
      }
    }
  }

  return (
    <div className="details-cards-header">
      <h3>
        <span>{incident ? incident.attributes.IncidentName : null}</span>
        {getTags(incident)}
      </h3>

      <span>
        {checkDirectorGroup(auth, directorGroup)}

        <Link
          to={
            window.location.search
              ? `/incidents/${window.location.search}`
              : '/incidents'
          }
        >
          <RaisedButton label="Close" />
        </Link>
      </span>
    </div>
  );
};

export default IncidentDetailsHeader;



// WEBPACK FOOTER //
// ./src/components/incidents/IncidentDetails/IncidentDetailsHeader.js